import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { WFormsTableWrapper } from '../table/WFormsTableWrapper';
import { IDs } from '../IDs';
import { RechteService } from '../../services/rechte_service';
import style from './WRechte.less';
import { WDnd } from '../forms/WDnd';

interface WRechteMainProps extends React.ClassAttributes<any> {
    modul: string;
    stamp: number;
    rechteBasis: any;
    costumClass?: string;
    formLayout?: string;
    onDataChange?: () => void;
}

interface WRechteMainState {
    access: Array<any>;
    showZuordnenDialog: any;
    showItem: any;
    rechtUsersLists: any;
    rechtGroupsLists: any;
}

export class WRechteMain extends React.Component<WRechteMainProps, WRechteMainState> {

    constructor(props: any) {
        super(props);
        this.state = {
            access: [],
            showZuordnenDialog: false,
            showItem: {},
            rechtUsersLists: {},
            rechtGroupsLists: {}
        };

        this.updateAccess = this.updateAccess.bind(this);
        this.prepareRechtUsersLists = this.prepareRechtUsersLists.bind(this);
        this.prepareRechtGroupsLists = this.prepareRechtGroupsLists.bind(this);
        this.saveRechtUsersLists = this.saveRechtUsersLists.bind(this);
        this.saveRechtGroupsLists = this.saveRechtGroupsLists.bind(this);
    }

    @lazyInject(RechteService) private rechteService: RechteService;

    private title = {
        SELECTED: 'zugeordnet',
        OPTIONS: 'nicht zugeordnet'
    };

    componentDidMount() {
        if (this.state.access.length === 0) {
            this.updateAccess();
        }
    }

    componentDidUpdate(preProps: any, preState: any) {
        if (preProps.stamp !== this.props.stamp) {
            this.updateAccess();
        }

        if (preState.showItem.tid !== this.state.showItem.tid) {
            this.prepareRechtUsersLists();
            this.prepareRechtGroupsLists();
        }
    }

    updateAccess() {
        const rechteBasis = this.props.rechteBasis;
        if (Array.isArray(rechteBasis.access) &&
            Array.isArray(rechteBasis.access_groups) &&
            Array.isArray(rechteBasis.access_user)) {

            const access: Array<any> = [];
            rechteBasis.access.map((ia: any) => {
                let cntGroup = 0;
                rechteBasis.access_groups.map((iag: any) => {
                    if (iag.access_id_orig === ia.tid) {
                        cntGroup++;
                    }
                });
                ia.cntGroup = cntGroup;

                let cntUser = 0;
                rechteBasis.access_user.map((iau: any) => {
                    if (iau.access_id_orig === ia.tid) {
                        cntUser++;
                    }
                });
                ia.cntUser = cntUser;

                access.push(ia);
            });

            // console.log(access);
            this.setState({ access });
        }
    }

    render() {
        const customActions = [
            {
                label: 'Benutzer und Gruppen zuordnen',
                key: 'REFERENCE',
                func: ((row: any) => {
                    this.setState({ showZuordnenDialog: true, showItem: row });
                    return;
                }),
                info: 'Benutzer und Gruppen zuordnen'
            }
        ];
        return (
            <div>
                <WFormsTableWrapper
                    module={this.props.modul}
                    entity={IDs.ENT_LEGACY_ACCESS}
                    data={this.state.access}
                    actions={['add', 'edit', 'delete']}
                    customActions={customActions}
                    customClass={this.props.costumClass ? this.props.costumClass : null}
                    formLayout={this.props.formLayout ? this.props.formLayout : null}
                    customColumns={[
                        { accessor: 'cntGroup', Header: 'Anzahl Gruppen', id: 'cntGroup' },
                        { accessor: 'cntUser', Header: 'Anzahl Benutzer', id: 'cntUser' }
                    ]}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' && typeof this.props.onDataChange === 'function') {
                            this.props.onDataChange();
                        }
                    }}
                />
                {this.state.showZuordnenDialog && this.showZuordnenDialog()}
            </div>
        );
    }

    showZuordnenDialog() {
        return (
            <div>
                <DialogWrapper2
                    title='Benutzer und Gruppen zuordnen'
                    onAfterClose={() => this.setState({ showZuordnenDialog: false, showItem: {} })}
                >
                    <div>
                        <div>
                            <div className={style.dnd_box}>
                                <div>Gruppen dieses Rechts</div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.rechtGroupsLists}
                                        onChange={(list: any) => this.setState({ rechtGroupsLists: list })}
                                    />
                                </div>
                            </div>
                            <div className={style.dnd_box}>
                                <div>Benutzer dieses Rechts</div>
                                <div>
                                    <WDnd
                                        title={this.title}
                                        lists={this.state.rechtUsersLists}
                                        onChange={(list: any) => this.setState({ rechtUsersLists: list })}
                                    />
                                </div>
                            </div>
                        </div>
                        <button
                            style={{ padding: '5px 10px', margin: 5, float: 'right' }}
                            onClick={() => {
                                this.setState({ showZuordnenDialog: false, showItem: {} });
                                // console.log(this.state);
                                // console.log(this.props.rechteBasis);
                                this.saveRechtUsersLists();
                                this.saveRechtGroupsLists();
                            }}>Speichern</button>
                    </div>
                </DialogWrapper2>
            </div>
        );
    }

    prepareRechtUsersLists() {
        const rechtUsersLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        console.log('User: ', this.props.rechteBasis.entity_user);
        if (Array.isArray(this.props.rechteBasis.entity_user)) {
            this.props.rechteBasis.entity_user.map((it: any) => {
                const login = it.login ? it.login : it.Login ? it.Login : it.name;
                if (!login || login === null) {
                    return;
                }
                rechtUsersLists.OPTIONS.push({
                    id: login,
                    content: login
                });
            });
        }
        if (this.state.showItem.tid && Array.isArray(this.props.rechteBasis.access_user)) {
            this.props.rechteBasis.access_user.map((it: any) => {
                if (it.access_id_orig === this.state.showItem.tid) {
                    const opIdx = rechtUsersLists.OPTIONS.findIndex((it2: any) => { return it2.id === it.name; });
                    if (opIdx >= 0) {
                        const opItemArray = rechtUsersLists.OPTIONS.splice(opIdx, 1);
                        rechtUsersLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        this.setState({ rechtUsersLists });
    }

    prepareRechtGroupsLists() {
        const rechtGroupsLists: any = {
            SELECTED: [],
            OPTIONS: []
        };
        if (Array.isArray(this.props.rechteBasis.group_index)) {
            this.props.rechteBasis.group_index.map((it: any) => {
                rechtGroupsLists.OPTIONS.push({
                    id: it.tid,
                    content: it.name
                });
            });
        }
        console.log(this.state.showItem, this.props.rechteBasis.access_groups);
        if (this.state.showItem.tid && Array.isArray(this.props.rechteBasis.access_groups)) {
            this.props.rechteBasis.access_groups.map((it: any) => {
                const group_id = it.group_id_orig || it.group_tid_orig;
                if (it.access_id_orig === this.state.showItem.tid) {
                    const opIdx = rechtGroupsLists.OPTIONS.findIndex((it2: any) => { return it2.id === group_id; });
                    if (opIdx >= 0) {
                        const opItemArray = rechtGroupsLists.OPTIONS.splice(opIdx, 1);
                        rechtGroupsLists.SELECTED.push(opItemArray[0]);
                    }
                }
            });
        }
        this.setState({ rechtGroupsLists });
    }

    saveRechtUsersLists() {
        const { rechtUsersLists } = this.state;
        const { SELECTED, OPTIONS } = rechtUsersLists;
        const access_user = this.props.rechteBasis.access_user;
        const accessId = this.state.showItem.tid;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const user = s.id;
            const fnd = access_user.find((au: any) => au.access_id_orig === accessId && au.name === user);
            if (!fnd) {
                console.log('addAccessUser', accessId, user);
                callCnt++;
                this.rechteService.addAccessUser(accessId, user, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const user = o.id;
            access_user.filter((au: any) => au.access_id_orig === accessId && au.name === user)
                .forEach((au: any) => {
                    console.log('delAccessUser', au.tid, user);
                    callCnt++;
                    this.rechteService.delAccessUser(au.tid, callback);
                });
        });
    }

    saveRechtGroupsLists() {
        const { rechtGroupsLists } = this.state;
        const { SELECTED, OPTIONS } = rechtGroupsLists;
        const access_groups = this.props.rechteBasis.access_groups;
        const accessId = this.state.showItem.tid;
        let callCnt = 0;

        const callback = () => {
            callCnt--;
            if (callCnt === 0) {
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            }
        };

        // selected but not exisits -> add
        SELECTED.forEach((s: any) => {
            const groupTid = parseInt(s.id, 10);
            const fnd = access_groups.find((ag: any) => ag.access_id_orig === accessId && ag.group_tid_orig === groupTid);
            if (!fnd) {
                console.log('addAccessGroups', accessId, groupTid);
                callCnt++;
                this.rechteService.addAccessGroups(groupTid, accessId, callback);
            }
        });
        // not selected but exists -> delete
        OPTIONS.forEach((o: any) => {
            const groupTid = parseInt(o.id, 10);
            access_groups.filter((ag: any) => ag.access_id_orig === accessId && ag.group_tid_orig === groupTid)
                .forEach((ag: any) => {
                    console.log('delAccessGroups', ag.tid, ag.group_tid);
                    callCnt++;
                    this.rechteService.delAccessGroups(ag.tid, groupTid, callback);
                });
        });
    }
}
